import { useContext } from 'react';
import { VideoCard } from 'ui/components/2-molecules/Card/VideoCard';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export const VideoCardFeature: React.FC<Umbraco.VideoCard> = ({ content, settings }) => {
	const dictionary = useContext(DictionaryContext);

	return (
		<VideoCard
			{...content?.properties}
			{...settings?.properties}
			consentHeading={dictionary.getValue('Video.ConsentHeading', null, 'Video unavailable')}
			consentText={dictionary.getValue(
				'Video.ConsentText',
				null,
				'To watch this video, please update your cookie preferences in the bottom-left corner of the page.',
			)}
		/>
	);
};
